import React, { useState } from "react";
import { useStepFormApi, BasicStepForm } from "components/StepForm";
import { ProgressSpinner } from "primereact/progressspinner";
import { BreadCrumb } from 'primereact/breadcrumb';
import { useNavigate } from "react-router-dom";
import { Step1 } from "./components/Step1";
import { Step2 } from "./components/Step2";
import { Step3 } from "./components/Step3";
import { Step4 } from "./components/Step4";
import { requestPostPackage } from "./api";
import { Button } from "primereact/button";
import { getUrlToListPackagesPage, getUrlToViewPackagePage } from "pages/urls";
import { ErrorInformation } from "components/ErrorInformation";

export function PostPackagePage() {
  return (
    <div
      style={{ maxWidth: "25rem" }}
      className="px-2 flex flex-column align-items-center mx-auto w-full"
    >
      <div className="w-full">
        <PostPackageForm />
      </div>
    </div>
  );
}

const UI_STATE = {
  INPUT: "input",
  SUBMITTING: "submitting",
  SUBMITTED: "submitted",
  SUBMIT_ERROR: "submit_error",
};

const steps = [
  { name: "Step 1", Component: Step1, valid: true, },
  { name: "Step 2", Component: Step2, valid: true, },
  { name: "Step 3", Component: Step3, data: { shouldSchedulePickup: false }, valid: true, },
  { name: "Step 4", Component: Step4, data: { donateUnsoldItems: false }, valid: true },
];

function PostPackageForm() {
  const navigate = useNavigate();
  const [uiState, setUiState] = useState<string>(UI_STATE.INPUT);
  const stepFormApi = useStepFormApi(steps, true);

  const handleFinish = async (data: Record<string, unknown>[]) => {
    const mergedStepData = Object.assign({}, ...data);
    try {
      setUiState(UI_STATE.SUBMITTING);
      const response = await requestPostPackage(mergedStepData);
      const created = await response.json();
      setUiState(UI_STATE.SUBMITTED);
      setTimeout(() => navigate(getUrlToViewPackagePage(created._id)), 1500);
    } catch (e) {
      setUiState(UI_STATE.SUBMIT_ERROR);
    }
  };

  const handleRetryRequest = () => {
    handleFinish(stepFormApi.data);
  };

  const handleEditForm = () => {
    stepFormApi.gotoStep(0);
    setUiState(UI_STATE.INPUT);
  };

  const header = (
    <BreadCrumb
      className="border-0 mb-2"
      model={[{ label: "Packages", command: () => navigate(getUrlToListPackagesPage()) }, { label: "Sell Items" }]}
      home={{ icon: "pi pi-box", command: () => navigate(getUrlToListPackagesPage()) }}
    />
  );

  switch (uiState) {
    case UI_STATE.INPUT:
      return (
        <div>
          {header}
          <div className="px-3">
            <BasicStepForm stepFormApi={stepFormApi} onFinish={handleFinish} />
          </div>
        </div>
      );
    case UI_STATE.SUBMITTING:
      return (
        <div className="text-center mt-8">
          <h2 className="mb-6 text-purple-600"> Submitting Request... </h2>
          <ProgressSpinner strokeWidth="4" />
          <p className="mt-5 mb-1">
            Hang Tight! We are creating your package.
          </p>
          <p className="mt-1"> This might take a bit. </p>
        </div>
      );
    case UI_STATE.SUBMITTED:
      return (
        <div className="text-center">
          <div className="text-green-500">
            <h2> Sell Request Created </h2>
            <span className="text-8xl"> 😎 </span>
          </div>
          <p className="mb-1"> Thank you for choosing to sell with Antidote! </p>
        </div>
      );
    case UI_STATE.SUBMIT_ERROR:
      return (
        <>
          {header}
          <ErrorInformation
            title="Sell Request Failed!"
            description='If you want to retry submitting right now then you can try one of the options below.'
            onRetryRequest={handleRetryRequest}
            actions={
              <Button
                onClick={handleEditForm}
                icon="pi pi-pencil"
                className="p-button-secondary p-button-text"
                label="Edit Details"
                aria-label="Edit Details"
              />
            }
          />
        </>
      )
    default:
      return null;
  }
}
